import { Box, InputAdornment, ListItem, Stack, styled, TableCell, Typography } from '@mui/material';

export const AllCapsSubheader = styled(Typography)(({ theme }) => ({
  textTransform: 'uppercase',
  paddingBottom: theme.spacing(2),
  fontSize: '12px',
  fontWeight: theme.typography.fontWeightMedium,
}));

export const AttachmentButton = styled('a')(({ theme }) => ({
  border: `1px solid ${theme.palette.border.main}`,
  borderRadius: theme.shape.borderRadius,
  color: 'inherit',
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(3),
  textDecoration: 'none',
  width: '100%',
}));

export const AttachmentSizeAndTypeText = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.body3.fontSize,
  color: theme.palette.text.tertiary,
}));

export const AttachmentTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: theme.typography.heading7.fontSize,
  fontWeight: theme.typography.fontWeightMediumBold,
}));

export const BasicInfoBox = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.border.main}`,
  borderRadius: theme.shape.borderRadius,
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(2),
  padding: theme.spacing(3),
}));

export const BulletListItem = styled(ListItem)({
  display: 'list-item',
  listStylePosition: 'outside',
});

export const CandidateModalContainer = styled(Box)((props) => ({
  [props.theme.breakpoints.up('xs')]: {
    width: '90%',
  },
  backgroundColor: 'white',
  borderRadius: props.theme.spacing(2),
  left: '50%',
  maxWidth: '900px',
  padding: '24px',
  position: 'absolute',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 100,
}));

export const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  maxWidth: '1200px',
  padding: theme.spacing(4),
  paddingTop: theme.spacing(4),
  width: '100%',
}));

export const DateText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.tertiary,
  fontSize: theme.typography.body3.fontSize,
}));

export const FormContainer = styled(Box)(({ theme }) => ({
  padding: `${theme.spacing(4)} ${theme.spacing(6.25)}`,
}));

export const GreyText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.disabled,
}));

export const ItalicsText = styled(Typography)(({ theme }) => ({
  fontStyle: 'italic',
  marginTop: theme.spacing(1),
  fontSize: theme.typography.body3.fontSize,
}));

export const Key = styled(Typography)(({ theme }) => ({
  display: 'inline',
  fontWeight: theme.typography.fontWeightMedium,
  color: theme.palette.text.primary,
}));

export const NoneFoundText = styled(Typography)(({ theme }) => ({
  paddingBottom: theme.spacing(2),
}));

export const PageContainer = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  marginTop: theme.spacing(1),
}));

export const StackRow = styled(Stack)(({ theme }) => ({
  marginTop: theme.spacing(0.75),
}));

export const StartAdornmentText = styled(InputAdornment)(({ theme }) => ({
  width: '25%',
  '.MuiTypography-root': {
    color: theme.palette.text.tertiary,
  },
}));

export const StyledHeaderTableCell = styled(TableCell)(({ theme }) => ({
  color: theme.palette.text.tertiary,
  padding: '6px 32px',
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: `${theme.spacing(3)} ${theme.spacing(4)}`,
}));

export const SubHeader = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
}));

export const Subtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: theme.typography.fontWeightMediumBold,
}));

export const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.black.dark,
  fontWeight: theme.typography.fontWeightMedium,
}));
